/**
 * Exact ("strict") search, always on.
 *
 * Shopify's default storefront search is fuzzy: an unquoted query returns the
 * exact matches first and then pads the list with approximate results that may
 * not contain the term at all. Wrapping each term in double quotes switches the
 * search engine to exact matching, and quoting every term keeps the "all words
 * must be present" behaviour shoppers expect from a multi word query.
 *
 *   hurricane 26   ->   "hurricane" "26"
 *
 * The quoting happens on submit only, so the shopper never gets to see it.
 * This file does three things:
 *   1. quotes the terms when a search form is submitted,
 *   2. cleans the search fields on load - Shopify hands the terms over HTML
 *      escaped in places, so a field can end up displaying &quot;Hurricane&quot;
 *      instead of Hurricane (this also fixes an already rendered page),
 *   3. nothing else: the query itself is carried in the URL, where the quotes
 *      are what keeps the results exact.
 */
(function () {
  var SEARCH_INPUT = 'input[name="q"]';
  var PREFIX_INPUT = 'input[name="options[prefix]"]';

  /**
   * Turns whatever the input holds into plain text: decodes the HTML entities
   * Shopify may have left in there and drops the quotes that mark exact search.
   */
  function cleanQuery(value) {
    return String(value == null ? '' : value)
      .replace(/&amp;/gi, '&')
      .replace(/&quot;/gi, '"')
      .replace(/&#0*34;/g, '"')
      .replace(/&#x0*22;/gi, '"')
      .replace(/&apos;/gi, "'")
      .replace(/&#0*39;/g, "'")
      .replace(/&#x0*27;/gi, "'")
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/"/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function quoteTerms(value) {
    return value
      .split(/\s+/)
      .filter(Boolean)
      .map(function (word) {
        return '"' + word.replace(/"/g, '') + '"';
      })
      .join(' ');
  }

  /**
   * Strips quotes and escaped characters from every visible search field.
   * Hidden query fields are left alone on purpose: those are the ones that carry
   * the quoted query into the filter and sort forms.
   */
  function cleanSearchFields() {
    var inputs = document.querySelectorAll(SEARCH_INPUT);
    Array.prototype.forEach.call(inputs, function (input) {
      if (input.type === 'hidden') return;
      var cleaned = cleanQuery(input.value);
      if (cleaned !== input.value) input.value = cleaned;
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      // only the header/search-page forms carry both fields
      var input = form.querySelector(SEARCH_INPUT);
      if (!input || !form.querySelector(PREFIX_INPUT)) return;

      var value = cleanQuery(input.value);
      if (!value) return;

      input.value = quoteTerms(value);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanSearchFields);
  } else {
    cleanSearchFields();
  }

  // the field can come back from the browser cache with the old value
  window.addEventListener('pageshow', cleanSearchFields);
  document.addEventListener('shopify:section:load', cleanSearchFields);
})();
